import {MainVideoState} from "../definitions/MainVideoState";

export const startedLoadingLoc = (state: MainVideoState) => {
    state.locationState.frameToLocFast = new Map();
    state.locationState.nearestLoc = undefined;
};
